import { render } from "./FiltersAdd.vue?vue&type=template&id=8a69ddde&scoped=true"
import script from "./FiltersAdd.vue?vue&type=script&lang=js"
export * from "./FiltersAdd.vue?vue&type=script&lang=js"

import "./FiltersAdd.vue?vue&type=style&index=0&id=8a69ddde&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a69ddde"]])

export default __exports__